import React, { useState } from "react";
import { IonItem, IonIcon, IonLabel, IonText, IonButton } from "@ionic/react";

import {
    chevronDownOutline,
    document,
    list,
    downloadOutline,
} from "ionicons/icons";

import "./AccordionItem.scss";
import { getFileUrl } from "../helpers/DevHelper";

type Props = {
    id: number;
    children?: any;
    type?: string;
    createdAt?: string;
    fileId?: string;
    related?: any;
    title?: string;
    sub_title?: string;
    companyName?: string;
};

const DocumentAccordionItem: React.FC<Props> = (props) => {
    const { children, type, createdAt, fileId, title, id, related, sub_title, companyName } =
        props;
    const [isOpen, setIsOpen] = useState(false);
    var dateFormat = require("dateformat");

    const handleOpen = () => {
        setIsOpen(!isOpen);
    };

    const getColor = () => {
        switch (type) {
            case "App\\Models\\DocumentCustomerContract":
                return "success";
            case "App\\Models\\DocumentInvoice":
                return "warning";
            case "App\\Models\\DocumentPatrolControl":
                return "danger";
            case "App\\Models\\DocumentProtocol":
                return "secondary";
            case "App\\Models\\DocumentEventList":
                return "danger";
            case "App\\Models\\DocumentReceiptConfirmation":
                return "primary";
            case "App\\Models\\DocumentWorksheet":
                return "primary";
            default:
                return "primary";
        }
    };

    return (
        <div className="accordionItemWrapper">
            <IonItem
                className={"accordionItem " + (isOpen ? "isOpen" : "")}
                lines="none"
                button={true}
                detail={false}
                onClick={() => handleOpen()}
            >
                <IonIcon
                    icon={document}
                    slot="start"
                    color={getColor()}
                    size="small"
                />
                <IonLabel>
                    <IonText color="secondary">
                        <h2 className="title">{title ?? ""}</h2>
                    </IonText>
                    {sub_title && (
                        <IonText color={getColor()}>
                            <p style={{margin: 0, fontSize: "inherit"}}><small>{sub_title ?? ""}</small></p>
                        </IonText>
                    )}
                    {companyName && (
                        <IonText color="medium">
                            <p style={{margin: 0, fontSize: "inherit"}}><small>Kiállító: {companyName}</small></p>
                        </IonText>
                    )}
                </IonLabel>
                <IonIcon
                    icon={chevronDownOutline}
                    slot="end"
                    size="small"
                    className="chevronIcon"
                />
            </IonItem>
            <div className={"subItem " + (isOpen ? "isOpen" : "")}>
                <div className="subItem-inner">
                    {/*<div className="list-between">
                        <span>File név:</span>
                        <span>{fileName??' - '}</span>
                    </div>
                    <div className="list-between">
                        <span>Méret:</span>
                        <span>{fileSize??' - '}</span>
                    </div>*/}
                    {type === "App\\Models\\DocumentEventList" &&
                        related &&
                        related.description && (
                            <div className="list-between">
                                <span>Leírás</span>
                                <span>{related.description ?? ""}</span>
                            </div>
                        )}
                    {type === "App\\Models\\DocumentEventList" &&
                        related &&
                        related.description && (
                            <div className="list-between">
                                <span>Időszak</span>
                                <span>
                                    {related.Idoszaktol
                                        ? dateFormat(
                                              related.Idoszaktol,
                                              "yyyy.mm.dd."
                                          )
                                        : ""}{" "}
                                    -{" "}
                                    {related.Idoszakig
                                        ? dateFormat(
                                              related.Idoszakig,
                                              "yyyy.mm.dd."
                                          )
                                        : ""}
                                </span>
                            </div>
                        )}

                    {type === "App\\Models\\DocumentCustomerContract" &&
                        related?.U_Sorszam && (
                            <div className="list-between">
                                <span>Sorszám</span>
                                <span>{related.U_Sorszam}</span>
                            </div>
                        )}
                    {type === "App\\Models\\DocumentReceiptConfirmation" &&
                        related?.Sorszam && (
                            <div className="list-between">
                                <span>Sorszám</span>
                                <span>{related.Sorszam}</span>
                            </div>
                        )}
                    {type === "App\\Models\\DocumentWorksheet" && related && (
                        <>
                            {related.Recontact && (
                                <div className="list-between">
                                    <span>Dátum</span>
                                    <span>{dateFormat(related.Recontact, "yyyy.mm.dd.")}</span>
                                </div>
                            )}
                            {related.CardCode && related.CardName && (
                                <div className="list-between">
                                    <span>Ügyfél</span>
                                    <span>{`${related.CardCode} - ${related.CardName}`}</span>
                                </div>
                            )}
                            {related.CntctSbjctName && (
                                <div className="list-between">
                                    <span>Munka típusa</span>
                                    <span>{related.CntctSbjctName}</span>
                                </div>
                            )}
                            {related.SzallitasiCimTeljes && (
                                <div className="list-between">
                                    <span>Cím</span>
                                    <span>{related.SzallitasiCimTeljes}</span>
                                </div>
                            )}
                        </>
                    )}

                    <div className="list-between">
                        <span>Feltöltve</span>
                        <span>
                            {createdAt
                                ? dateFormat(createdAt, "yyyy.mm.dd. HH:MM")
                                : ""}
                        </span>
                    </div>

                    {children ?? ""}

                    <br />
                    <div className="rightButton">
                        <IonButton
                            size="small"
                            routerLink={"/my/documents/view/" + id}
                            routerDirection="forward"
                            color="primary"
                        >
                            <IonIcon icon={list} slot="start" />
                            Részletek
                        </IonButton>
                        {fileId && (
                            <IonButton
                                size="small"
                                href={getFileUrl() + "/" + fileId}
                                target="_blank"
                                color="success"
                            >
                                <IonIcon icon={downloadOutline} slot="start" />
                                PDF megnyitása
                            </IonButton>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentAccordionItem;
